// FloatingWhatsapp.jsx
import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const FloatingWhatsapp = () => {
  return (
    <a
      href={`https://wa.me/2348029958684?text=Hello%20I%20am%20interested%20in%20your%20services.%20I%20am%20currently%20on%20${encodeURIComponent(window.location.href)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-36 left-6 z-[99999] bg-green-500 hover:bg-green-600 text-white w-14 h-14 flex items-center justify-center rounded-full shadow-lg animate-bounce"
      title="Chat with us on WhatsApp"
    >
      <FaWhatsapp size={28} />
     
      
    </a>
  );
};

export default FloatingWhatsapp;
